import {getDownloadURL, ref, uploadBytes} from 'firebase/storage';
import {firebaseStorage} from '../../../config/firebase';

/**
 * Uploads a file to Firebase Storage and returns the download URL
 * @param file - The file to upload
 * @param path - The storage path where the file will be uploaded
 * @returns Promise that resolves to the download URL
 * @throws Error if upload fails
 */
export default async function uploadStorageFile(file: File, path: string): Promise<string> {
  const storageRef = ref(firebaseStorage, path);
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
}
